/* Event Calendar */
var EventCalendar = function () {
    var currentContext = $();

    var moduleOptions = {
        eventsSearchUrl: "",
        datepicker: {
            dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            onSelect: function (date) {
            }
        }
    };

    function buildCalendar() {
        var calendarOptions = $.extend({}, moduleOptions.datepicker);

        if(moduleOptions.eventsSearchUrl) {
            calendarOptions.onSelect = (date) => window.location.href = moduleOptions.eventsSearchUrl;
        };

        currentContext.datepicker(calendarOptions); 
    };

    this.init = function (context, options) {
        currentContext = context || currentContext;
        $.extend(moduleOptions, options);
        
        buildCalendar();
    };

    return this;
};

module.exports = EventCalendar;
